//import * as types from '../actions/actionTypes';
import initialState from '../store/initialState';

const sponsors  = (state = initialState.sponsors, action) => {
    switch (action.type) {

        default:
            return state
    }
}

export default sponsors;
